"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenInvalidError = exports.TokenExpiredError = void 0;
const ApiErrorBase_1 = require("./ApiErrorBase");
class TokenExpiredError extends ApiErrorBase_1.ApiErrorBase {
    constructor(code, message, canRetry) {
        super(code, message, canRetry);
    }
}
exports.TokenExpiredError = TokenExpiredError;
class TokenInvalidError extends ApiErrorBase_1.ApiErrorBase {
    constructor(code, message, canRetry) {
        super(code, message, canRetry);
    }
}
exports.TokenInvalidError = TokenInvalidError;
//# sourceMappingURL=ApiErrors.js.map